import { IoCalendarOutline } from "react-icons/io5";
import { useState, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Daily from "./DailyFilter";
import Monthly from "./MonthlyFilter";
import { getCustomDashboardUrl } from "../../api/endpoints";
import { refreshUserToken } from "../../tools/refreshToken";

const DashboardFilter = ({ dashboardTimeline, updateDateDashboardToRender, setDashboardData, setRawData, setIsLoading, setDashboardDataCopy }) => {
  const [openModal, setOpenModal] = useState(false);
  const [filterScreen, setFilterScreen] = useState("daily");
  const [yearTofetch, setYearToFetch] = useState(new Date().getFullYear());
  const [weekToFetch, setWeekToFetch] = useState(""); /* by years week number e.g week 2 (8 jan-16 jan)*/
  const [monthToFetch, setMonthToFetch] = useState(""); /* by month Name */
  const [isFilterParamsValid, setIsFilterParamsValid] = useState(false);

  const navigate = useNavigate();
  useLayoutEffect(() => {
    setFilterScreen("daily");
  }, [openModal]);
  useLayoutEffect(() => {
    /* reset weektofetch */
    console.log("resetting week to fetch");
    setWeekToFetch("");
    console.log(weekToFetch);
  }, [yearTofetch]);
  useLayoutEffect(() => {
    if (filterScreen === "daily") {
      if (yearTofetch && weekToFetch) {
        setIsFilterParamsValid(true);
      } else {
        setIsFilterParamsValid(false);
      }
    } else {
      if (yearTofetch && monthToFetch) {
        setIsFilterParamsValid(true);
      } else {
        setIsFilterParamsValid(false);
      }
    }
  }, [yearTofetch, monthToFetch, weekToFetch, filterScreen]);

  const filtertrainChange = (e, choosen) => {
    let train = document.querySelector(".movingTrainTab3");
    let target = e.target;
    let parNode = target.parentNode;
    if (choosen === "daily") {
      setFilterScreen("daily");
      train.style.left = "2px";
      Array.from(parNode.children).forEach((child) => {
        child.classList.remove("selectedtrainfilter3");
      });
      target.classList.add("selectedtrainfilter3");
    } else if (choosen === "monthly") {
      setFilterScreen("monthly");
      train.style.left = "49.3%";
      Array.from(parNode.children).forEach((child) => {
        child.classList.remove("selectedtrainfilter3");
      });
      target.classList.add("selectedtrainfilter3");
    }
  };

  const toUppercase = (string) => {
    console.log(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const toggleShowFIlter = () => {
    let tab = document.querySelector(".dashboardTimeline > div");
    tab.classList.toggle("showDashTimeLine");
  };

  const handleClick = () => {
    toggleShowFIlter();
    if (filterScreen === "daily") {
      fetchCustomDashboard("daily");
    } else {
      fetchCustomDashboard("monthly");
    }
  };

  const fetchCustomDashboard = async (whichInterval) => {
    setIsLoading(true);
    try {
      let response = await fetch(getCustomDashboardUrl + whichInterval, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({
          year: yearTofetch,
          month: whichInterval === "monthly" ? monthToFetch : null,
          weekNo: whichInterval === "daily" ? weekToFetch.split(" ")[1] : null,
        }),
      });

      if (response.ok) {
        let { rawData, reducedData } = await response.json();
        setRawData(rawData);
        setDashboardData(reducedData);
        console.log(reducedData, rawData, "custom dashboard data");
        let dashboardTimeline = yearTofetch + " " + (whichInterval === "daily" ? weekToFetch : monthToFetch);
        console.log(dashboardTimeline, "dashboardTimeline");

        updateDateDashboardToRender(dashboardTimeline);
        setDashboardDataCopy(reducedData);
        setIsLoading(false);
        setOpenModal(false);
      } else if (response.status === 404) {
        alert("choosen range is not valid, please choose a valid range");
        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(getCustomDashboardUrl + whichInterval, fetchCustomDashboard, navigate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='dashboardFilterWrapper2'>
        <div className='dashboardTimeline'>
          <IoCalendarOutline size={18} />
          {/* <p>2 may</p>
          <p>-</p>
          <p>4 may</p> */}
          <p onClick={toggleShowFIlter}>{toUppercase(dashboardTimeline)}</p>
          <div style={{ bottom: dashboardTimeline !== "today" && dashboardTimeline !== "yesterday" ? "-171px" : "-129px" }}>
            {dashboardTimeline !== "today" && (
              <p
                onClick={() => {
                  updateDateDashboardToRender("today");
                  toggleShowFIlter();
                }}
              >
                {" "}
                Today
              </p>
            )}
            {dashboardTimeline !== "yesterday" && (
              <p
                onClick={() => {
                  updateDateDashboardToRender("yesterday");
                  toggleShowFIlter();
                }}
              >
                {" "}
                Yesterday
              </p>
            )}
            <p onClick={() => setOpenModal(true)}>Choose interval</p>
          </div>
        </div>
        {/* <div>
          <p>Choose interval</p>
        </div> */}
        {openModal && (
          <span onClick={() => setOpenModal(false)} className='filterScreendash3'>
            <div onClick={(e) => e.stopPropagation()} className='filterdiv21'>
              <h4>Choose interval</h4>
              <div className='filterTabs232'>
                <p
                  onClick={(e) => {
                    filtertrainChange(e, "daily");
                  }}
                >
                  Daily
                </p>
                <p
                  onClick={(e) => {
                    filtertrainChange(e, "monthly");
                  }}
                >
                  Monthly
                </p>
                <div className='movingTrainTab3'></div>
              </div>

              {filterScreen === "daily" ? (
                <Daily yearTofetch={yearTofetch} updateYearToFetch={setYearToFetch} weekToFetch={weekToFetch} updateWeekToFetch={setWeekToFetch} />
              ) : (
                <Monthly yearTofetch={yearTofetch} updateYearToFetch={setYearToFetch} monthToFetch={monthToFetch} updateMonthToFetch={setMonthToFetch} />
              )}

              <div className='filterButtons'>
                {isFilterParamsValid ? (
                  <button onClick={handleClick}>Get dashboard</button>
                ) : (
                  <button style={{ opacity: "0.6", cursor: "not-allowed" }}>Get dashboard</button>
                )}
              </div>
            </div>
          </span>
        )}
      </div>
    </>
  );
};

export default DashboardFilter;
